module.exports = __webpack_public_path__ + "img/TW_B.3ef5939c.png";